import React from 'react';
import { Input, Label, FormGroup } from 'reactstrap';

const INVENTORY_FIELDS = [
  { name: 'plumillas', label: 'Plumillas' },
  { name: 'radio', label: 'Radio' },
  { name: 'panel_radio', label: 'Panel radio' },
  { name: 'herramientas', label: 'Herramientas' },
  { name: 'gata', label: 'Gata' },
  { name: 'extintor', label: 'Extintor' },
  { name: 'botiquin', label: 'Botiquín' },
  { name: 'permiso_circulacion', label: 'Permiso circulación' },
  { name: 'libro_garantia', label: 'Libro garantía' },
  { name: 'encendedor', label: 'Encendedor' },
  { name: 'accesorios', label: 'Accesorios' },
  { name: 'neumatico_repuesto', label: 'Neumático repuesto' },
  { name: 'tapa_rueda', label: 'Tapa rueda' },
  { name: 'cubre_pisos', label: 'Cubre pisos' },
];

const InventorySection = ({
  inventory,
  sinInventario,
  onInventoryChange,
  onSinInventarioChange,
  error,
}) => {
  const handleSiChange = (fieldName) => (e) => {
    if (e.target.checked) {
      onInventoryChange(fieldName, true);
    }
  };

  const handleNoChange = (fieldName) => (e) => {
    if (e.target.checked) {
      onInventoryChange(fieldName, false);
    }
  };

  const handleObservacionesChange = (e) => {
    onInventoryChange('observaciones', e.target.value);
  };

  return (
    <>
      <div className="row">
        <div className="col-6">
          <Label for="sin_inventario">Sin inventario</Label>
        </div>
        <div className="col-6">
          <Input
            type="checkbox"
            id="sin_inventario"
            name="sin_inventario"
            checked={sinInventario}
            onChange={onSinInventarioChange}
          />
        </div>
      </div>

      {!sinInventario && (
        <>
          {error && (
            <div className="text-danger small mb-2 mt-2">{error}</div>
          )}
          <div className="d-flex align-items-center my-2">
            <div className="flex-grow-1 border-top"></div>
            <span className="mx-3 text-muted fw-bold">Inventario</span>
            <div className="flex-grow-1 border-top"></div>
          </div>

          <div className="row fw-bold mb-2">
            <div className="col-1">SÍ</div>
            <div className="col-1">NO</div>
            <div className="col-10">ITEM</div>
          </div>

          {INVENTORY_FIELDS.map((field) => {
            const value = inventory?.[field.name];
            const siChecked = value === true;
            const noChecked = value === false;
            const ambosUnchecked = value === null || value === undefined;

            return (
              <div className="row" key={field.name}>
                <div className="col-1">
                  <Input
                    type="checkbox"
                    id={`${field.name}_si`}
                    name={`${field.name}_si`}
                    checked={siChecked}
                    aria-label={`SÍ ${field.label}`}
                    onChange={handleSiChange(field.name)}
                  />
                </div>
                <div className="col-1">
                  <Input
                    type="checkbox"
                    id={`${field.name}_no`}
                    name={`${field.name}_no`}
                    checked={noChecked}
                    aria-label={`NO ${field.label}`}
                    onChange={handleNoChange(field.name)}
                  />
                </div>
                <div className="col-10 d-flex align-items-center">
                  <Label>{field.label}</Label>
                </div>
              </div>
            );
          })}

          <div className="row">
            <FormGroup>
              <Label for="observaciones_inventario">Observaciones de inventario</Label>
              <Input
                type="textarea"
                id="observaciones_inventario"
                name="observaciones_inventario"
                value={inventory?.observaciones || ''}
                onChange={handleObservacionesChange}
                placeholder="Observaciones adicionales..."
                rows="3"
              />
            </FormGroup>
          </div>
        </>
      )}
    </>
  );
};

export default InventorySection;
